import { Handlebars } from '../../Utility/Handlebars/databaseHandlebars';
import { Template } from '../Template';

/**
 * Base class for Handlebars Templates
 */
export class HandlebarsTemplate<
    HandlebarsContext extends Record<string, unknown>
> extends Template {
    /**
     * Returns the template string with css included
     */
    private getTemplateString(): string {
        return `${this.css ? `<style>${this.css}</style>` : ''}${this.html}`;
    }

    /**
     * Insert HTML to wrapper node
     */
    async render(context: HandlebarsContext): Promise<void> {
        const handlebarsDelegate = Handlebars.compile(this.getTemplateString());
        this.wrapperElement.innerHTML = handlebarsDelegate(context);

        //run script tags
        //Code taken from https://stackoverflow.com/questions/2592092/executing-script-elements-inserted-with-innerhtml/47614491#47614491
        Array.from(this.wrapperElement.querySelectorAll('script')).forEach((oldScript) => {
            const newScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach((attr) =>
                newScript.setAttribute(attr.name, attr.value)
            );

            newScript.appendChild(document.createTextNode(oldScript.innerHTML));
            oldScript.parentNode?.replaceChild(newScript, oldScript);
        });
    }
}
